export const environmentBase = {
  production: false,
  apiBaseUrl: '',
  timeout: 30000,
  appName: 'NextUp',
  version: '0.1.0',
  debug: false,
  features: {
    enableAnalytics: false,
    enableLogging: false,
    enableCache: false
  },
  
};